module.exports = __webpack_public_path__ + "static/media/FotosCentro8.48d1f7fa.jpg";